import dayjs from "dayjs";

/**
 * 3-literowe skróty dni tygodnia w panelu – jeden zestaw dla nagłówków
 * kalendarzy PrimeNG (`dayNamesMin` w AppComponent), checkboxów i etykiet dat.
 * Indeks jak `Date.getDay()` / `dayjs().day()`: 0 = niedziela.
 */
export const WEEKDAY_SHORT_PL = [
  "Nie",
  "Pon",
  "Wto",
  "Śro",
  "Czw",
  "Pią",
  "Sob",
] as const;

/** Skrót dnia tygodnia dla daty „YYYY-MM-DD” (np. „2026-11-11” → „Śro”). */
export function weekdayShortPl(day: string): string {
  return WEEKDAY_SHORT_PL[dayjs(day).day()];
}
